import React, { Component, useRef } from "react";
import moment from "moment";
import API from "../../apiService.js";
import ReactToPrint from "react-to-print";
import ReactPaginate from "react-paginate";
import BlobPrint from "../component/BlobPrint";
const inputRefs = [];
export default class History extends Component {
    setRef = (ref, id) => {
        inputRefs[id] = ref;
    };
    constructor(props) {
        super(props);
        this.state = {
            histories: [],
            show: false,
            datas: [],
            condition: null,
            open: null,
            status: "Tidak Ada Diagnosa",
            organization: null,

        };
    }
    onReload = () => {
        this.props.history.push("/pelayanan");
    };
    componentDidMount() {
        this.getHistories();
    }
    getHistories = async () => {
        const res = await API.get(
            "fhir/satu_sehat/encounter/" + this.props.detilPx.patients.id_ihs
        );
        console.log(res)
        if (res.success) {
            this.setState({
                histories: res.data.entry,
                datas: res.data.entry,
            });
        }
    };
    getCondition = async (id, key, url) => {
        this.setState({ status: "Proses loading data...." });
        const res = await API.get(
            "fhir/satu_sehat/condition/" + this.props.detilPx.patients.id_ihs + "/" + id
        );
        if (res.success) {
            let par = {
                url: url,
                method: "GET",
                payload: null
            }
            const org = await API.post(
                "fhir/satu_sehat/manual", par
            );
            if (org?.success) {
                this.setState({
                    organization: org.data?.name
                })
            } else {
                this.setState({
                    organization: null
                })
            }

            this.setState({
                condition: res.data.entry,
                open: key
            });
            if (res.data.total == 0) {
                this.setState({ status: "Tidak Ditemukan Data" });

            }
        } else {
            this.setState({ open: key })
        }
    };
    setAge(d) {
        var b = moment(d);
        var a = new Date();

        a = moment(a);

        var years = a.diff(b, "year");
        b.add(years, "years");

        var months = a.diff(b, "months");
        b.add(months, "months");

        var days = a.diff(b, "days");

        if (years !== 0 && months == 0 && days == 0) {
            return years + " Tahun (Hari Lahir Pasien)";
        } else if (years == 0 && months == 0) {
            return days + " Hari";
        } else if (years == 0 && days == 0) {
            return months + " Bulan";
        } else if (years == 0) {
            return months + " Bulan " + days + " Hari";
        } else {
            return years + " Tahun " + months + " Bulan " + days + " Hari";
        }
    }

    handleBeforeGetContent = () => {
        return new Promise((resolve, reject) => {
            this.setState({ show: true }, () => resolve());
        });
    };
    changePage = async (e) => {
        const res = await API.get(
            "registration/history/" + this.props.detilPx.patients.id + "?page=" + e
        );
        if (res.code === 200) {
            this.setState({
                histories: res.data.histories.data,
                datas: res.data.histories,
            });
        }
    };

    getView(id) {
        let view = [];
        let cond = this.state.condition;
        if (cond) {
            cond.map((a, b) => {
                if (a.resource.code) {
                    for (let index = 0; index < a.resource.code.coding.length; index++) {
                        const element = a.resource.code.coding[index];
                        view.push(
                            <div className="row">
                                <div className="col-md-6">
                                    {element.code}
                                    {/* {JSON.stringify(a.resource.code)} */}
                                </div>
                                <div className="col-md-6">
                                    {element.display}
                                    {/* {JSON.stringify(a.resource.code)} */}
                                </div>
                            </div>
                        )

                    }

                }
            })

        } else {
            view.push(
                <div className="row">
                    <div className="col-md-12">
                        {this.state.status}
                    </div>
                </div>
            )
        }
        return view
    }


    render() {
        let patient = this.props.detilPx;
        let Age = this.setAge(patient.patients.birth_date);
        console.log(this.state);
        return (
            <div>
                <div className="card">
                    <div className="card-header">
                        <h3>Histori Pelayanan</h3>
                    </div>
                    <div className="card-body">
                        <div className="accordion" id="accordionRiwo">
                            {this.state.histories?.map((history, key) => (
                                <div className="card" key={key} >
                                    <div
                                        className="card-header"
                                        id={"heading_" + key}
                                        data-toggle="collapse"
                                        data-target={"#collapse_" + key}
                                        aria-expanded={this.state.open == key ? true : false}
                                        aria-controls={"collapse_" + key}
                                        onClick={(e) => { this.setState({ condition: null }); this.getCondition(history?.resource?.id, key, history?.resource?.serviceProvider?.reference) }}
                                        ref={(ref) => this.setRef(ref, key)}
                                    >
                                        {/* {`${history?.resource?.id} ${history?.resource?.serviceProvider?.reference} ${history?.resource?.status}`} */}
                                        {`${moment(history?.resource?.period?.start).format('LLLL')}, Status Pemeriksaan : ${history?.resource?.status}`}

                                    </div>
                                    <div
                                        id={"collapse_" + key}
                                        className={this.state.open == key ? "collapse show" : "collapse"}
                                        aria-labelledby={"heading_" + key}
                                    >
                                        <div
                                            className="card-body"
                                            ref={(el) => (this[`componentRef${key}`] = el)}
                                        >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    Nama Faskes
                                                </div>
                                                <div className="col-md-6">
                                                    {this.state.organization}
                                                </div>
                                                <div className="col-md-6">
                                                    ID
                                                </div>
                                                <div className="col-md-6">
                                                    {history?.resource?.id}
                                                </div>
                                            </div>
                                            <hr />
                                            {this.getView(history?.resource?.id)}
                                            {/* <div>loop</div> */}

                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="card-footer">
                        <button className="btn btn-danger" onClick={this.onReload}>
                            Tutup
            </button>
                    </div>
                </div>
            </div>
        );
    }
}
